function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import '../Charts.scss';
import React, { Component } from 'react';
import { AVIChartTile } from '../../Layout/AVIChartTile/AVIChartTile';
import { BaseMixin } from '../Mixins/BaseMixin';
import { CapMixin } from '../Mixins/CapMixin';
import { ColorMixin } from '../Mixins/ColorMixin';
import PropTypes from 'prop-types';
import { TileMixin } from '../Mixins/TileMixin';
import dc from 'dc';
import { withAVIDashboardContext } from '../../Context/AVIDashboard/AVIDashboard';
export var PieChart = /*#__PURE__*/function (_Component) {
  _inheritsLoose(PieChart, _Component);

  function PieChart(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.chartRef = React.createRef();
    _this.legendRef = React.createRef();
    _this.chart = null;
    _this.getChart = _this.getChart.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = PieChart.prototype;

  _proto.getChart = function getChart() {
    return this.chart;
  };

  _proto.circularLegend = function circularLegend(chart) {
    if (!this.props.showLegend) {
      var legendItem = chart.selectAll('.dc-legend-item');
      var legendSymbol = legendItem.select('rect');
      legendSymbol.remove();
      legendItem.insert('circle', ':first-child').attr('cy', 5).attr('r', 8).attr('fill', function (d) {
        return d.color;
      });
    } else {
      var legendItems = document.querySelectorAll('.dc-legend-item-color');

      for (var i = 0; i < legendItems.length; i++) {
        legendItems[i].style.borderRadius = '50%';
      }
    }
  };

  _proto.renderCustomTitle = function renderCustomTitle(chart) {
    var customTitleFormat = this.props.customTitleFormat;
    chart.selectAll('title').remove();
    chart.selectAll('g.pie-slice').append('svg:title').attr('class', 'barTitle').attr('fill', '#ffffff').attr('color', '#000000').text(function (d) {
      return customTitleFormat(d.data);
    });
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.chart = dc.pieChart(this.chartRef.current);
    BaseMixin(this.chart, this.props);
    CapMixin(this.chart, this.props);
    ColorMixin(this.chart, this.props);
    TileMixin(this.chart, this.props);
    var _this$props = this.props,
        drawPaths = _this$props.drawPaths,
        radius = _this$props.radius,
        innerRadius = _this$props.innerRadius,
        slicesCap = _this$props.slicesCap,
        externalLabels = _this$props.externalLabels,
        minAngleForLabel = _this$props.minAngleForLabel,
        externalRadiusPadding = _this$props.externalRadiusPadding,
        label = _this$props.label,
        renderLabel = _this$props.renderLabel,
        showLegend = _this$props.showLegend,
        legend = _this$props.legend,
        circularLegend = _this$props.circularLegend,
        renderlet = _this$props.renderlet,
        legendItemSymbol = _this$props.legendItemSymbol,
        renderCustomTitle = _this$props.renderCustomTitle;
    this.chart.radius(radius).drawPaths(drawPaths).innerRadius(innerRadius).slicesCap(slicesCap).minAngleForLabel(minAngleForLabel).externalLabels(externalLabels).externalRadiusPadding(externalRadiusPadding).label(label).renderLabel(renderLabel);

    if (showLegend) {
      this.chart.legend(dc.htmlLegend().container(this.legendRef.current).legendItemClass('legend-item').legendText(function (d) {
        return d.name;
      }));
    }

    if (legend) {
      this.chart.legend(legend());
    } // TODO: circularLegend is deprecated


    if (renderCustomTitle || circularLegend || legendItemSymbol === 'circle') {
      this.chart.on('pretransition', function (chart) {
        renderCustomTitle && _this2.renderCustomTitle(chart);

        _this2.circularLegend(chart);
      });
    }

    if (renderlet && typeof renderlet === 'function') {
      this.chart.on('renderlet', renderlet);
    }

    this.chart.render();

    if (this.props.register) {
      this.props.register(this.chart, this.props.name);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.unregister) {
      this.props.unregister(this.chart, this.props.name);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevProps.group !== this.props.group || prevProps.dimension !== this.props.dimension) {
      this.chart.dimension(this.props.dimension).group(this.props.group).redraw();
    }

    if (prevProps.legend !== this.props.legend) {
      this.chart.legend(this.props.legend()).render();
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        chartTitle = _this$props2.chartTitle,
        showTools = _this$props2.showTools,
        toolsComponent = _this$props2.toolsComponent,
        showLegend = _this$props2.showLegend;
    return /*#__PURE__*/React.createElement(AVIChartTile, {
      title: chartTitle,
      getChart: this.getChart,
      showTools: showTools,
      toolsComponent: toolsComponent
    }, /*#__PURE__*/React.createElement("div", {
      className: 'avi-chart chart pie-chart',
      ref: this.chartRef
    }), /*#__PURE__*/React.createElement("div", {
      className: ['avi-chart', 'legend', showLegend ? 'show' : ''].join(' '),
      ref: this.legendRef
    }));
  };

  return PieChart;
}(Component);

_defineProperty(PieChart, "defaultProps", {
  drawPaths: false,
  radius: 100,
  innerRadius: 0,
  slicesCap: 15,
  externalLabels: 0,
  minAngleForLabel: 0.25,
  externalRadiusPadding: 0,
  label: function label(d) {
    return d.key + " (" + d.value + ")";
  },
  renderLabel: true,
  renderCustomTitle: false,
  customTitleFormat: function customTitleFormat(d) {
    return d.key + " (" + d.value + ")";
  },

  /** @deprecated Since 08.09.2020 */
  circularLegend: false,
  legendItemSymbol: 'rect'
});

PieChart.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Get or set whether to draw lines from pie slices to their labels. */
  drawPaths: PropTypes.bool,

  /** Get or set the outer radius. If the radius is not set, it will be half of the minimum of the chart width and height. */
  radius: PropTypes.number,

  /** Get or set the inner radius of the pie chart. If the inner radius is greater than 0px then the pie chart will be rendered as a doughnut chart. */
  innerRadius: PropTypes.number,

  /** Get or set the maximum number of slices the pie chart will generate. The top slices are determined by value from high to low. Other slices exeeding the cap will be rolled up into one single Others slice. */
  slicesCap: PropTypes.number,

  /** Position slice labels offset from the outer edge of the chart. The argument specifies the extra radius to be added for slice labels. */
  externalLabels: PropTypes.number,

  /** Get or set the minimal slice angle for label rendering. Any slice with a smaller angle will not display a slice label. */
  minAngleForLabel: PropTypes.number,

  /** Get or set the external radius padding of the pie chart. This will force the radius of the pie chart to become smaller or larger depending on the value. */
  externalRadiusPadding: PropTypes.number,

  /** Key name of the chart used by `AVIDashboardContext` in terms of the mapping name and id in the `register` method */
  name: PropTypes.string,

  /** `AVIChartTile` content. */
  chartTitle: PropTypes.string,

  /** Turn on/off label rendering */
  renderLabel: PropTypes.bool,

  /** Set to render legends in a separate collapsible div */
  showLegend: PropTypes.bool,

  /** Use dc legend og dc.htmlLegend to render legends, could be combined with showLegend, if not legend container is renderd as children */
  legend: PropTypes.func,

  /** The shape of the legend item symbol - can be rectangular or circular */
  legendItemSymbol: PropTypes.oneOf(['rect', 'circle']),

  /** Optional renderlet function that will be triggered after the chart is drawn, can be used for advanced purposes  */
  renderlet: PropTypes.func,

  /** A function that is used to derive the value from a dc group */
  valueAccessor: PropTypes.func,

  /** Label number format  */
  label: PropTypes.func,

  /** Render SVG:title tag, i.e. "tooltip" labels when holding the mouse above a pie chart slice */
  renderCustomTitle: PropTypes.bool,

  /** Label number format  */
  customTitleFormat: PropTypes.func
} : {};
export default withAVIDashboardContext(PieChart);